export const keypadServiceConstants = {
    GET_KEYPADSERVICE_REQUEST: "GET_KEYPADSERVICE_REQUEST",
    GET_KEYPADSERVICE_SUCCESS: "GET_KEYPADSERVICE_SUCCESS",
    GET_KEYPADSERVICE_FAILURE: "GET_KEYPADSERVICE_FAILURE"
};